<template>
  <section class="sharkbet-bonuses" :class="`sharkbet-bonuses--${variant}`">
    <h2>MIS BONIFICACIONES</h2>
    <div class="sharkbet-bonuses__tabs" role="tablist" aria-label="Bonificaciones">
      <button type="button" :class="{ 'is-active': activeTab === 'active' }" @click="activeTab = 'active'">BONOS ACTIVOS</button>
      <button type="button" :class="{ 'is-active': activeTab === 'available' }" @click="activeTab = 'available'">BONOS DISPONIBLES</button>
      <button type="button" :class="{ 'is-active': activeTab === 'history' }" @click="activeTab = 'history'">HISTORIAL DE BONOS</button>
    </div>

    <div v-if="activeTab !== 'history'" class="sharkbet-bonuses__empty">
      <i class="fas fa-info-circle" aria-hidden="true"></i>
      {{ activeTab === 'active' ? 'No tiene bonificaciones activas.' : 'No tiene bonificaciones disponibles.' }}
    </div>

    <template v-else>
      <label class="sharkbet-bonuses__search">Filtrar resultados
        <span><i class="fas fa-search" aria-hidden="true"></i><input v-model.trim="search" type="search" aria-label="Filtrar historial de bonos"></span>
      </label>
      <div class="sharkbet-bonuses__table-wrap">
        <table class="sharkbet-bonuses__table">
          <thead><tr><th>Fecha de creación</th><th>Nombre</th><th>Monto</th><th>Categoría</th><th>Fecha de cierre</th></tr></thead>
          <tbody><tr><td colspan="5">No hay historial de bonificaciones</td></tr></tbody>
        </table>
      </div>
      <div class="sharkbet-bonuses__history-footer">
        <span>{{ historyRecords.length }} Registros</span>
        <button v-if="hasMoreHistory" type="button" @click="visibleHistoryCount += 10">Mostrar mas</button>
      </div>
    </template>
  </section>
</template>

<script>
export default {
  name: 'SharkbetBonuses',
  props: {
    variant: { type: String, default: 'desktop' },
  },
  data() {
    return { activeTab: 'active', historyRecords: [], search: '', visibleHistoryCount: 10 };
  },
  computed: {
    hasMoreHistory() {
      return this.historyRecords.length > this.visibleHistoryCount;
    },
  },
};
</script>

<style scoped>
.sharkbet-bonuses h2 {
  color: #17212a;
  font: 400 30px 'Roboto', sans-serif;
  margin: 0 0 26px;
}

.sharkbet-bonuses__tabs {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
}

.sharkbet-bonuses__tabs button {
  background: #dedede;
  border: 0;
  border-radius: 28px 28px 0 0;
  color: #7a8790;
  cursor: pointer;
  font: 500 14px 'Roboto', sans-serif;
  height: 49px;
  white-space: nowrap;
}

.sharkbet-bonuses__tabs button.is-active {
  background: #f6f6f6;
  color: #17212a;
}

.sharkbet-bonuses__empty {
  align-items: center;
  background: #e0f5ff;
  color: #08719e;
  display: flex;
  font: 14px 'Roboto', sans-serif;
  gap: 14px;
  margin: 24px;
  padding: 15px 18px;
}

.sharkbet-bonuses__empty i {
  font-size: 18px;
}

.sharkbet-bonuses__search {
  align-items: center;
  background: #f6f6f6;
  color: #17212a;
  display: flex;
  font: 500 16px 'Roboto', sans-serif;
  gap: 10px;
  padding: 24px 24px 16px;
}

.sharkbet-bonuses__search span {
  align-items: center;
  background: #fff;
  border: 1px solid #c8c8c8;
  border-radius: 22px;
  display: flex;
  height: 40px;
  padding: 0 12px;
  width: 220px;
}

.sharkbet-bonuses__search i {
  color: #777;
}

.sharkbet-bonuses__search input {
  background: transparent;
  border: 0;
  color: #17212a;
  font: 14px 'Roboto', sans-serif;
  min-width: 0;
  outline: 0;
  padding: 0 8px;
  width: 100%;
}

.sharkbet-bonuses__table-wrap {
  background: #f6f6f6;
  padding: 0 24px 24px;
}

.sharkbet-bonuses__table {
  border-collapse: separate;
  border-spacing: 0;
  color: #7a8790;
  font: 12px 'Roboto', sans-serif;
  min-width: 680px;
  width: 100%;
}

.sharkbet-bonuses__table-wrap { overflow-x: auto; }

.sharkbet-bonuses__table th {
  background: #0089b8;
  border-right: 1px solid #52606a;
  color: #fff;
  font-weight: 600;
  padding: 16px 8px;
  text-align: center;
}

.sharkbet-bonuses__table th:first-child { border-radius: 20px 0 0 0; }
.sharkbet-bonuses__table th:last-child { border-radius: 0 20px 0 0; border-right: 0; }

.sharkbet-bonuses__table td {
  background: #fafafa;
  border: 1px solid #52606a;
  border-bottom: 0;
  color: #7a8790;
  padding: 24px 8px;
  text-align: center;
}

.sharkbet-bonuses__table td[colspan] { border-radius: 0 0 20px 20px; }

.sharkbet-bonuses__history-footer {
  background: #f6f6f6;
  display: grid;
  gap: 10px;
  padding: 0 24px 24px;
}

.sharkbet-bonuses__history-footer span {
  color: #7a8790;
  font: 12px 'Roboto', sans-serif;
}

.sharkbet-bonuses__history-footer button {
  background: #0092cd;
  border: 0;
  border-radius: 18px;
  color: #fff;
  cursor: pointer;
  font: 600 12px 'Roboto', sans-serif;
  height: 29px;
  justify-self: start;
  padding: 0 14px;
}

@media (max-width: 767px) {
  .sharkbet-bonuses__tabs button { font-size: 11px; }
  .sharkbet-bonuses__empty { margin: 16px; }
  .sharkbet-bonuses__search { align-items: flex-start; flex-direction: column; padding: 16px; }
  .sharkbet-bonuses__search span { width: 100%; }
  .sharkbet-bonuses__table-wrap { padding: 0 16px 16px; }
  .sharkbet-bonuses__history-footer { padding: 0 16px 16px; }
}
</style>
